//everything to deal with connecting to firebase
import { initializeApp } from "firebase/app";
import {getFirestore} from "@firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import {GoogleAuthProvider,getAuth,signInWithPopup,signInWithEmailAndPassword,
    createUserWithEmailAndPassword,sendPasswordResetEmail,signOut} from "firebase/auth";
import {query,getDocs,collection,where,addDoc,updateDoc,doc,deleteDoc,orderBy} from "firebase/firestore";
import { NewTeamCompMessage } from "./discord-webhook"; 



const firebaseConfig = {
    apiKey: "AIzaSyAgU28v6rjbJVG_M6hYeV87_xIYc4Tq6BA",
    authDomain: "impulsiveempathyvalorant.firebaseapp.com",
    databaseURL: "https://impulsiveempathyvalorant-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "impulsiveempathyvalorant",
    storageBucket: "impulsiveempathyvalorant.appspot.com",
    messagingSenderId: "198333170985",
    appId: "1:198333170985:web:5991869afbc6bf14d9a338",
    measurementId: "G-0VKEFW8H4M"
  };

const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
    try {
        const res = await signInWithPopup(auth, googleProvider);
        const user = res.user;
        const q = query(collection(db, "users"), where("uid", "==", user.uid));
        const docs = await getDocs(q);
        if (docs.docs.length === 0) {
        await addDoc(collection(db, "users"), {
            uid: user.uid,
            name: user.displayName,
            authProvider: "google",
            email: user.email,
        });
        }
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

const addtoqueue = async (user) => {
  try {
    await addDoc(collection(db, "queue"), 
    { 
      name:user,
      time:Date.now()
    }
      )
    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

const promotetomod = async (user) => {
  try {
    //get docref queue with name == user
    const q = query(collection(db, "users"), where("valorant_name", "==", user));
    const doco = await getDocs(q);
    const id_to_change = doco.docs[0].id;
    const docref_change = doc(db,"users",id_to_change)
    updateDoc(docref_change,{"type_user":"moderator"});
  } catch (error) {
    console.log(error)
  }
}

const demotetouser = async (user) => {
  try {
    //get docref queue with name == user
    const q = query(collection(db, "users"), where("valorant_name", "==", user));
    const doco = await getDocs(q);
    const id_to_change = doco.docs[0].id;
    const docref_change = doc(db,"users",id_to_change)
    updateDoc(docref_change,{"type_user":"user"});
  } catch (error) {
    console.log(error)
  }
}

const deletefromqueue = async (user) => {
  try {
    //get docref queue with name == user
    const q = query(collection(db, "queue"), where("name", "==", user));
    const doco = await getDocs(q);
    const id_to_delete = doco.docs[0].id;
    const docref_delete = doc(db,"queue",id_to_delete)
    await deleteDoc(docref_delete)
    return false
  } catch (error) {
    console.log(error)
    return true
  }
}

const bumptofirst = async (user) => {
  /* 
  1: get docid of the user to update
  2: get docid of the first in queue
  3: get time of person in first queue
  4: change time to be less then the person first in queue
   */
  console.log(user);
  const q = query(collection(db, "queue"), where("name", "==", user));
  const doco = await getDocs(q);
  const id_to_change = doco.docs[0].id;
  const docref_change = doc(db,"queue",id_to_change)

  const qt = query(collection(db,"queue"), orderBy("time", "asc"));
  const docot = await getDocs(qt);
  const to_get_time = docot.docs[0].data().time;
  
  const toupdatetime = to_get_time - 1;
  updateDoc(docref_change,{"name":user,"time":toupdatetime});

}

const clearqueue = async() => {
  const q = query(collection(db, "queue"));
  const all_queue_members = await getDocs(q);
  for (let i = 0; i < all_queue_members.docs.length; i++) {
    const id_to_delete = all_queue_members.docs[i].id;
    const docref_delete = doc(db,"queue",id_to_delete)
    await deleteDoc(docref_delete)
  }
}

const deletefrommatch = async(user,team) => {
  const q = query(collection(db, "current_match"));
  const current_match_doc = await getDocs(q);

  //get next in line queue
  const qnil = query(collection(db,"queue"), orderBy("time", "asc"));
  const current_queue = await getDocs(qnil);
  const replac_user = current_queue.docs[0].data().name;
  const current_match = current_match_doc.docs[0].data();
  console.log(current_match_doc.docs[0].id);
  const docref_change = doc(db,"current_match",current_match_doc.docs[0].id)
  const replacement_user = {"name":replac_user,"anchored":false}
  if(team == "blue"){
    const usersteam = current_match_doc.docs[0].data().team_blue
    const index = usersteam.findIndex(x => x.name ===user.name);
    console.log(index);
    if (index > -1) {
      usersteam.splice(index, 1); 
    }
    usersteam.push(replacement_user)
    console.log(usersteam);
    // update current_match
    current_match.team_blue = usersteam;
    // update record of current_match
    updateDoc(docref_change,current_match);
  }else{
    const usersteam = current_match_doc.docs[0].data().team_red
    const index = usersteam.findIndex(x => x.name ===user.name);
    if (index > -1) {
      usersteam.splice(index, 1);
    }
    usersteam.push(replacement_user)
    // update current_match
    current_match.team_red = usersteam;
    updateDoc(docref_change,current_match);
  }
  
  //lastly delete replacement user from queue
  await deletefromqueue(replac_user);
}

function capFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

const getBoolRegistration = async() => {
  const q = query(collection(db, "registration_tournament"));
  const all_tournaments = await getDocs(q);
  for (let i = 0; i < all_tournaments.docs.length; i++) {
    if(all_tournaments.docs[i].data().open == true){
      return true
    }
  }
  return false
}

const leaveTournament = async(user, tourney) => {
  const q = query(collection(db, "registration_tournament"));
  const all_tournaments = await getDocs(q);
  for (let i = 0; i < all_tournaments.docs.length; i++) {
    if(all_tournaments.docs[i].data().tournament_name == tourney){
      var tochangedoc = all_tournaments.docs[i].data();
      var docref_change = doc(db,"registration_tournament",all_tournaments.docs[i].id);
      console.log(docref_change);
      const index = all_tournaments.docs[i].data().participants.findIndex(x => x.valo_name ===user);
      console.log(index);
      if (index > -1) {
        tochangedoc.participants.splice(index, 1); 
      }
      updateDoc(docref_change,tochangedoc);
    }
  }
}

const joinTournament = async(user, tourney) => {
  const q = query(collection(db, "registration_tournament"));
  const all_tournaments = await getDocs(q);
  
  for (let i = 0; i < all_tournaments.docs.length; i++) {
    var data_tournament = all_tournaments.docs[i].data()
    if(data_tournament.tournament_name == tourney){
      var docref_change = doc(db,"registration_tournament",all_tournaments.docs[i].id);
      console.log(docref_change);
      const z = query(collection(db, "users"), where("valorant_name", "==", user));
      const docsz = await getDocs(z);
      const data = docsz.docs[0].data();
      var rank = data.tier_value;
      var participants = data_tournament.participants
      participants.push({rank:rank,valo_name:user});
      data_tournament.participants = participants
      console.log(data_tournament);
      updateDoc(docref_change,data_tournament);
    }
  }
}

const getBoolUserInTourney = async(user, tourney) => {
  const q = query(collection(db, "registration_tournament"));
  const all_tournaments = await getDocs(q);
  for (let i = 0; i < all_tournaments.docs.length; i++) {
    if(all_tournaments.docs[i].data().tournament_name == tourney){
      try {
        for (let y = 0; i < all_tournaments.docs[i].data().participants.length; y++) {
          console.log(all_tournaments.docs[i].data().participants[y].valo_name)
          if(all_tournaments.docs[i].data().participants[y].valo_name == user){
            return true
          }
        }
      } catch (error) {
          if(all_tournaments.docs[i].data().participants.valo_name == user){
            return true
          }
      }
      
    }
  }
  return false
}

const get_all_registrable_tournaments = async() => {
  const q = query(collection(db, "registration_tournament"), where("open", "==", true));
  const all_open_tournaments = await getDocs(q);
  return all_open_tournaments
}

function generateName(){
  var name1 = ["abandoned","able","absolute","adorable","adventurous","academic","acceptable","acclaimed","accomplished","accurate","aching","acidic","acrobatic","active","actual","adept","admirable","admired","adolescent","adorable","adored","advanced","afraid","affectionate","aged","aggravating","aggressive","agile","agitated","agonizing","agreeable","ajar","alarmed","alarming","alert","alienated","alive","all","altruistic","amazing","ambitious","ample","amused","amusing","anchored","ancient","angelic","angry","anguished","animated","annual","another","antique","anxious","any","apprehensive","appropriate","apt","arctic","arid","aromatic","artistic","ashamed","assured","astonishing","athletic","attached","attentive","attractive","austere","authentic","authorized","automatic","avaricious","average","aware","awesome","awful","awkward","babyish","bad","back","baggy","bare","barren","basic","beautiful","belated","beloved","beneficial","better","best","bewitched","big","big-hearted","biodegradable","bite-sized","bitter","black","black-and-white","bland","blank","blaring","bleak","blind","blissful","blond","blue","blushing","bogus","boiling","bold","bony","boring","bossy","both","bouncy","bountiful","bowed","brave","breakable","brief","bright","brilliant","brisk","broken","bronze","brown","bruised","bubbly","bulky","bumpy","buoyant","burdensome","burly","bustling","busy","buttery","buzzing","calculating","calm","candid","canine","capital","carefree","careful","careless","caring","cautious","cavernous","celebrated","charming","cheap","cheerful","cheery","chief","chilly","chubby","circular","classic","clean","clear","clear-cut","clever","close","closed","cloudy","clueless","clumsy","cluttered","coarse","cold","colorful","colorless","colossal","comfortable","common","compassionate","competent","complete","complex","complicated","composed","concerned","concrete","confused","conscious","considerate","constant","content","conventional","cooked","cool","cooperative","coordinated","corny","corrupt","costly","courageous","courteous","crafty","crazy","creamy","creative","creepy","criminal","crisp","critical","crooked","crowded","cruel","crushing","cuddly","cultivated","cultured","cumbersome","curly","curvy","cute","cylindrical","damaged","damp","dangerous","dapper","daring","darling","dark","dazzling","dead","deadly","deafening","dear","dearest","decent","decimal","decisive","deep","defenseless","defensive","defiant","deficient","definite","definitive","delayed","delectable","delicious","delightful","delirious","demanding","dense","dental","dependable","dependent","descriptive","deserted","detailed","determined","devoted","different","difficult","digital","diligent","dim","dimpled","dimwitted","direct","disastrous","discrete","disfigured","disgusting","disloyal","dismal","distant","downright","dreary","dirty","disguised","dishonest","dismal","distant","distinct","distorted","dizzy","dopey","doting","double","downright","drab","drafty","dramatic","dreary","droopy","dry","dual","dull","dutiful","each","eager","earnest","early","easy","easy-going","ecstatic","edible","educated","elaborate","elastic","elated","elderly","electric","elegant","elementary","elliptical","embarrassed","embellished","eminent","emotional","empty","enchanted","enchanting","energetic","enlightened","enormous","enraged","entire","envious","equal","equatorial","essential","esteemed","ethical","euphoric","even","evergreen","everlasting","every","evil","exalted","excellent","exemplary","exhausted","excitable","excited","exciting","exotic","expensive","experienced","expert","extraneous","extroverted","extra-large","extra-small","fabulous","failing","faint","fair","faithful","fake","false","familiar","famous","fancy","fantastic","far","faraway","far-flung","far-off","fast","fat","fatal","fatherly","favorable","favorite","fearful","fearless","feisty","feline","female","feminine","few","fickle","filthy","fine","finished","firm","first","firsthand","fitting","fixed","flaky","flamboyant","flashy","flat","flawed","flawless","flickering","flimsy","flippant","flowery","fluffy","fluid","flustered","focused","fond","foolhardy","foolish","forceful","forked","formal","forsaken","forthright","fortunate","fragrant","frail","frank","frayed","free","French","fresh","frequent","friendly","frightened","frightening","frigid","frilly","frizzy","frivolous","front","frosty","frozen","frugal","fruitful","full","fumbling","functional","funny","fussy","fuzzy","gargantuan","gaseous","general","generous","gentle","genuine","giant","giddy","gigantic","gifted","giving","glamorous","glaring","glass","gleaming","gleeful","glistening","glittering","gloomy","glorious","glossy","glum","golden","good","good-natured","gorgeous","graceful","gracious","grand","grandiose","granular","grateful","grave","gray","great","greedy","green","gregarious","grim","grimy","gripping","grizzled","gross","grotesque","grouchy","grounded","growing","growling","grown","grubby","gruesome","grumpy","guilty","gullible","gummy","hairy","half","handmade","handsome","handy","happy","happy-go-lucky","hard","hard-to-find","harmful","harmless","harmonious","harsh","hasty","hateful","haunting","healthy","heartfelt","hearty","heavenly","heavy","hefty","helpful","helpless","hidden","hideous","high","high-level","hilarious","hoarse","hollow","homely","honest","honorable","honored","hopeful","horrible","hospitable","hot","huge","humble","humiliating","humming","humongous","hungry","hurtful","husky","icky","icy","ideal","idealistic","identical","idle","idiotic","idolized","ignorant","ill","illegal","ill-fated","ill-informed","illiterate","illustrious","imaginary","imaginative","immaculate","immaterial","immediate","immense","impassioned","impeccable","impartial","imperfect","imperturbable","impish","impolite","important","impossible","impractical","impressionable","impressive","improbable","impure","inborn","incomparable","incompatible","incomplete","inconsequential","incredible","indelible","inexperienced","indolent","infamous","infantile","infatuated","inferior","infinite","informal","innocent","insecure","insidious","insignificant","insistent","instructive","insubstantial","intelligent","intent","intentional","interesting","internal","international","intrepid","ironclad","irresponsible","irritating","itchy","jaded","jagged","jam-packed","jaunty","jealous","jittery","joint","jolly","jovial","joyful","joyous","jubilant","judicious","juicy","jumbo","junior","jumpy","juvenile","kaleidoscopic","keen","key","kind","kindhearted","kindly","klutzy","knobby","knotty","knowledgeable","knowing","known","kooky","kosher","lame","lanky","large","last","lasting","late","lavish","lawful","lazy","leading","lean","leafy","left","legal","legitimate","light","lighthearted","likable","likely","limited","limp","limping","linear","lined","liquid","little","live","lively","livid","loathsome","lone","lonely","long","long-term","loose","lopsided","lost","loud","lovable","lovely","loving","low","loyal","lucky","lumbering","luminous","lumpy","lustrous","luxurious","mad","made-up","magnificent","majestic","major","male","mammoth","married","marvelous","masculine","massive","mature","meager","mealy","mean","measly","meaty","medical","mediocre","medium","meek","mellow","melodic","memorable","menacing","merry","messy","metallic","mild","milky","mindless","miniature","minor","minty","miserable","miserly","misguided","misty","mixed","modern","modest","moist","monstrous","monthly","monumental","moral","mortified","motherly","motionless","mountainous","muddy","muffled","multicolored","mundane","murky","mushy","musty","muted","mysterious","naive","narrow","nasty","natural","naughty","nautical","near","neat","necessary","needy","negative","neglected","negligible","neighboring","nervous","new","next","nice","nifty","nimble","nippy","nocturnal","noisy","nonstop","normal","notable","noted","noteworthy","novel","noxious","numb","nutritious","nutty","obedient","obese","oblong","oily","oblong","obvious","occasional","odd","oddball","offbeat","offensive","official","old","old-fashioned","only","open","optimal","optimistic","opulent","orange","orderly","organic","ornate","ornery","ordinary","original","other","our","outlying","outgoing","outlandish","outrageous","outstanding","oval","overcooked","overdue","overjoyed","overlooked","palatable","pale","paltry","parallel","parched","partial","passionate","past","pastel","peaceful","peppery","perfect","perfumed","periodic","perky","personal","pertinent","pesky","pessimistic","petty","phony","physical","piercing","pink","pitiful","plain","plaintive","plastic","playful","pleasant","pleased","pleasing","plump","plush","polished","polite","political","pointed","pointless","poised","poor","popular","portly","posh","positive","possible","potable","powerful","powerless","practical","precious","present","prestigious","pretty","precious","previous","pricey","prickly","primary","prime","pristine","private","prize","probable","productive","profitable","profuse","proper","proud","prudent","punctual","pungent","puny","pure","purple","pushy","putrid","puzzled","puzzling","quaint","qualified","quarrelsome","quarterly","queasy","querulous","questionable","quick","quick-witted","quiet","quintessential","quirky","quixotic","quizzical","radiant","ragged","rapid","rare","rash","raw","recent","reckless","rectangular","ready","real","realistic","reasonable","red","reflecting","regal","regular","reliable","relieved","remarkable","remorseful","remote","repentant","required","respectful","responsible","repulsive","revolving","rewarding","rich","rigid","right","ringed","ripe","roasted","robust","rosy","rotating","rotten","rough","round","rowdy","royal","rubbery","rundown","ruddy","rude","runny","rural","rusty","sad","safe","salty","same","sandy","sane","sarcastic","sardonic","satisfied","scaly","scarce","scared","scary","scented","scholarly","scientific","scornful","scratchy","scrawny","second","secondary","second-hand","secret","self-assured","self-reliant","selfish","sentimental","separate","serene","serious","serpentine","several","severe","shabby","shadowy","shady","shallow","shameful","shameless","sharp","shimmering","shiny","shocked","shocking","shoddy","short","short-term","showy","shrill","shy","sick","silent","silky","silly","silver","similar","simple","simplistic","sinful","single","sizzling","skeletal","skinny","sleepy","slight","slim","slimy","slippery","slow","slushy","small","smart","smoggy","smooth","smug","snappy","snarling","sneaky","sniveling","snoopy","sociable","soft","soggy","solid","somber","some","spherical","sophisticated","sore","sorrowful","soulful","soupy","sour","Spanish","sparkling","sparse","specific","spectacular","speedy","spicy","spiffy","spirited","spiteful","splendid","spotless","spotted","spry","square","squeaky","squiggly","stable","staid","stained","stale","standard","starchy","stark","starry","steep","sticky","stiff","stimulating","stingy","stormy","straight","strange","steel","strict","strident","striking","striped","strong","studious","stunning","stupendous","stupid","sturdy","stylish","subdued","submissive","substantial","subtle","suburban","sudden","sugary","sunny","super","superb","superficial","superior","supportive","sure-footed","surprised","suspicious","svelte","sweaty","sweet","sweltering","swift","sympathetic","tall","talkative","tame","tan","tangible","tart","tasty","tattered","taut","tedious","teeming","tempting","tender","tense","tepid","terrible","terrific","testy","thankful","that","these","thick","thin","third","thirsty","this","thorough","thorny","those","thoughtful","threadbare","thrifty","thunderous","tidy","tight","timely","tinted","tiny","tired","torn","total","tough","traumatic","treasured","tremendous","tragic","trained","tremendous","triangular","tricky","trifling","trim","trivial","troubled","true","trusting","trustworthy","trusty","truthful","tubby","turbulent","twin","ugly","ultimate","unacceptable","unaware","uncomfortable","uncommon","unconscious","understated","unequaled","uneven","unfinished","unfit","unfolded","unfortunate","unhappy","unhealthy","uniform","unimportant","unique","united","unkempt","unknown","unlawful","unlined","unlucky","unnatural","unpleasant","unrealistic","unripe","unruly","unselfish","unsightly","unsteady","unsung","untidy","untimely","untried","untrue","unused","unusual","unwelcome","unwieldy","unwilling","unwitting","unwritten","upbeat","upright","upset","urban","usable","used","useful","useless","utilized","utter","vacant","vague","vain","valid","valuable","vapid","variable","vast","velvety","venerated","vengeful","verifiable","vibrant","vicious","victorious","vigilant","vigorous","villainous","violet","violent","virtual","virtuous","visible","vital","vivacious","vivid","voluminous","wan","warlike","warm","warmhearted","warped","wary","wasteful","watchful","waterlogged","watery","wavy","wealthy","weak","weary","webbed","wee","weekly","weepy","weighty","weird","welcome","well-documented","well-groomed","well-informed","well-lit","well-made","well-off","well-to-do","well-worn","wet","which","whimsical","whirlwind","whispered","white","whole","whopping","wicked","wide","wide-eyed","wiggly","wild","willing","wilted","winding","windy","winged","wiry","wise","witty","wobbly","woeful","wonderful","wooden","woozy","wordy","worldly","worn","worried","worrisome","worse","worst","worthless","worthwhile","worthy","wrathful","wretched","writhing","wrong","wry","yawning","yearly","yellow","yellowish","young","youthful","yummy","zany","zealous","zesty","zigzag","rocky"];

  var name2 = ["people","history","way","art","world","information","map","family","government","health","system","computer","meat","year","thanks","music","person","reading","method","data","food","understanding","theory","law","bird","literature","problem","software","control","knowledge","power","ability","economics","love","internet","television","science","library","nature","fact","product","idea","temperature","investment","area","society","activity","story","industry","media","thing","oven","community","definition","safety","quality","development","language","management","player","variety","video","week","security","country","exam","movie","organization","equipment","physics","analysis","policy","series","thought","basis","boyfriend","direction","strategy","technology","army","camera","freedom","paper","environment","child","instance","month","truth","marketing","university","writing","article","department","difference","goal","news","audience","fishing","growth","income","marriage","user","combination","failure","meaning","medicine","philosophy","teacher","communication","night","chemistry","disease","disk","energy","nation","road","role","soup","advertising","location","success","addition","apartment","education","math","moment","painting","politics","attention","decision","event","property","shopping","student","wood","competition","distribution","entertainment","office","population","president","unit","category","cigarette","context","introduction","opportunity","performance","driver","flight","length","magazine","newspaper","relationship","teaching","cell","dealer","debate","finding","lake","member","message","phone","scene","appearance","association","concept","customer","death","discussion","housing","inflation","insurance","mood","woman","advice","blood","effort","expression","importance","opinion","payment","reality","responsibility","situation","skill","statement","wealth","application","city","county","depth","estate","foundation","grandmother","heart","perspective","photo","recipe","studio","topic","collection","depression","imagination","passion","percentage","resource","setting","ad","agency","college","connection","criticism","debt","description","memory","patience","secretary","solution","administration","aspect","attitude","director","personality","psychology","recommendation","response","selection","storage","version","alcohol","argument","complaint","contract","emphasis","highway","loss","membership","possession","preparation","steak","union","agreement","cancer","currency","employment","engineering","entry","interaction","limit","mixture","preference","region","republic","seat","tradition","virus","actor","classroom","delivery","device","difficulty","drama","election","engine","football","guidance","hotel","match","owner","priority","protection","suggestion","tension","variation","anxiety","atmosphere","awareness","bread","climate","comparison","confusion","construction","elevator","emotion","employee","employer","guest","height","leadership","mall","manager","operation","recording","respect","sample","transportation","boring","charity","cousin","disaster","editor","efficiency","excitement","extent","feedback","guitar","homework","leader","mom","outcome","permission","presentation","promotion","reflection","refrigerator","resolution","revenue","session","singer","tennis","basket","bonus","cabinet","childhood","church","clothes","coffee","dinner","drawing","hair","hearing","initiative","judgment","lab","measurement","mode","mud","orange","poetry","police","possibility","procedure","queen","ratio","relation","restaurant","satisfaction","sector","signature","significance","song","tooth","town","vehicle","volume","wife","accident","airport","appointment","arrival","assumption","baseball","chapter","committee","conversation","database","enthusiasm","error","explanation","farmer","gate","girl","hall","historian","hospital","injury","instruction","maintenance","manufacturer","meal","perception","pie","poem","presence","proposal","reception","replacement","revolution","river","son","speech","tea","village","warning","winner","worker","writer","assistance","breath","buyer","chest","chocolate","conclusion","contribution","cookie","courage","desk","drawer","establishment","examination","garbage","grocery","honey","impression","improvement","independence","insect","inspection","inspector","king","ladder","menu","penalty","piano","potato","profession","professor","quantity","reaction","requirement","salad","sister","supermarket","tongue","weakness","wedding","affair","ambition","analyst","apple","assignment","assistant","bathroom","bedroom","beer","birthday","celebration","championship","cheek","client","consequence","departure","diamond","dirt","ear","fortune","friendship","funeral","gene","girlfriend","hat","indication","intention","lady","midnight","negotiation","obligation","passenger","pizza","platform","poet","pollution","recognition","reputation","shirt","speaker","stranger","surgery","sympathy","tale","throat","trainer","uncle","youth","time","work","film","water","money","example","while","business","study","game","life","form","air","day","place","number","part","field","fish","back","process","heat","hand","experience","job","book","end","point","type","home","economy","value","body","market","guide","interest","state","radio","course","company","price","size","card","list","mind","trade","line","care","group","risk","word","fat","force","key","light","training","name","school","top","amount","level","order","practice","research","sense","service","piece","web","boss","sport","fun","house","page","term","test","answer","sound","focus","matter","kind","soil","board","oil","picture","access","garden","range","rate","reason","future","site","demand","exercise","image","case","cause","coast","action","age","bad","boat","record","result","section","building","mouse","cash","class","period","plan","store","tax","side","subject","space","rule","stock","weather","chance","figure","man","model","source","beginning","earth","program","chicken","design","feature","head","material","purpose","question","rock","salt","act","birth","car","dog","object","scale","sun","note","profit","rent","speed","style","war","bank","craft","half","inside","outside","standard","bus","exchange","eye","fire","position","pressure","stress","advantage","benefit","box","frame","issue","step","cycle","face","item","metal","paint","review","room","screen","structure","view","account","ball","discipline","medium","share","balance","bit","black","bottom","choice","gift","impact","machine","shape","tool","wind","address","average","career","culture","morning","pot","sign","table","task","condition","contact","credit","egg","hope","ice","network","north","square","attempt","date","effect","link","post","star","voice","capital","challenge","friend","self","shot","brush","couple","exit","front","function","lack","living","plant","plastic","spot","summer","taste","theme","track","wing","brain","button","click","desire","foot","gas","influence","notice","rain","wall","base","damage","distance","feeling","pair","savings","staff","sugar","target","text","animal","author","budget","discount","file","ground","lesson","minute","officer","phase","reference","register","sky","stage","stick","title","trouble","bowl","bridge","campaign","character","club","edge","evidence","fan","letter","lock","maximum","novel","option","pack","park","quarter","skin","sort","weight","baby","background","carry","dish","factor","fruit","glass","joint","master","muscle","red","strength","traffic","trip","vegetable","appeal","chart","gear","ideal","kitchen","land","log","mother","net","party","principle","relative","sale","season","signal","spirit","street","tree","wave","belt","bench","commission","copy","drop","minimum","path","progress","project","sea","south","status","stuff","ticket","tour","angle","blue","breakfast","confidence","daughter","degree","doctor","dot","dream","duty","essay","father","fee","finance","hour","juice","luck","milk","mouth","peace","pipe","stable","storm","substance","team","trick","afternoon","bat","beach","blank","catch","chain","consideration","cream","crew","detail","gold","interview","kid","mark","mission","pain","pleasure","score","screw","sex","shop","shower","suit","tone","window","agent","band","bath","block","bone","calendar","candidate","cap","coat","contest","corner","court","cup","district","door","east","finger","garage","guarantee","hole","hook","implement","layer","lecture","lie","manner","meeting","nose","parking","partner","profile","rice","routine","schedule","swimming","telephone","tip","winter","airline","bag","battle","bed","bill","bother","cake","code","curve","designer","dimension","dress","ease","emergency","evening","extension","farm","fight","gap","grade","holiday","horror","horse","host","husband","loan","mistake","mountain","nail","noise","occasion","package","patient","pause","phrase","proof","race","relief","sand","sentence","shoulder","smoke","stomach","string","tourist","towel","vacation","west","wheel","wine","arm","aside","associate","bet","blow","border","branch","breast","brother","buddy","bunch","chip","coach","cross","document","draft","dust","expert","floor","god","golf","habit","iron","judge","knife","landscape","league","mail","mess","native","opening","parent","pattern","pin","pool","pound","request","salary","shame","shelter","shoe","silver","tackle","tank","trust","assist","bake","bar","bell","bike","blame","boy","brick","chair","closet","clue","collar","comment","conference","devil","diet","fear","fuel","glove","jacket","lunch","monitor","mortgage","nurse","pace","panic","peak","plane","reward","row","sandwich","shock","spite","spray","surprise","till","transition","weekend","welcome","yard","alarm","bend","bicycle","bite","blind","bottle","cable","candle","clerk","cloud","concert","counter","flower","grandfather","harm","knee","lawyer","leather","load","mirror","neck","pension","plate","purple","ruin","ship","skirt","slice","snow","specialist","stroke","switch","trash","tune","zone","anger","award","bid","bitter","boot","bug","camp","candy","carpet","cat","champion","channel","clock","comfort","cow","crack","engineer","entrance","fault","grass","guy","hell","highlight","incident","island","joke","jury","leg","lip","mate","motor","nerve","passage","pen","pride","priest","prize","promise","resident","resort","ring","roof","rope","sail","scheme","script","sock","station","toe","tower","truck","witness","can","will","other","use","make","good","look","help","go","great","being","still","public","read","keep","start","give","human","local","general","specific","long","play","feel","high","put","common","set","change","simple","past","big","possible","particular","major","personal","current","national","cut","natural","physical","show","try","check","second","call","move","pay","let","increase","single","individual","turn","ask","buy","guard","hold","main","offer","potential","professional","international","travel","cook","alternative","special","working","whole","dance","excuse","cold","commercial","low","purchase","deal","primary","worth","fall","necessary","positive","produce","search","present","spend","talk","creative","tell","cost","drive","green","support","glad","remove","return","run","complex","due","effective","middle","regular","reserve","independent","leave","original","reach","rest","serve","watch","beautiful","charge","active","break","negative","safe","stay","visit","visual","affect","cover","report","rise","walk","white","junior","pick","unique","classic","final","lift","mix","private","stop","teach","western","concern","familiar","fly","official","broad","comfortable","gain","rich","save","stand","young","heavy","lead","listen","valuable","worry","handle","leading","meet","release","sell","finish","normal","press","ride","secret","spread","spring","tough","wait","brown","deep","display","flow","hit","objective","shoot","touch","cancel","chemical","cry","dump","extreme","push","conflict","eat","fill","formal","jump","kick","opposite","pass","pitch","remote","total","treat","vast","abuse","beat","burn","deposit","print","raise","sleep","somewhere","advance","consist","dark","double","draw","equal","fix","hire","internal","join","kill","sensitive","tap","win","attack","claim","constant","drag","drink","guess","minor","pull","raw","soft","solid","wear","weird","wonder","annual","count","dead","doubt","feed","forever","impress","repeat","round","sing","slide","strip","wish","combine","command","dig","divide","equivalent","hang","hunt","initial","march","mention","spiritual","survey","tie","adult","brief","crazy","escape","gather","hate","prior","repair","rough","sad","scratch","sick","strike","employ","external","hurt","illegal","laugh","lay","mobile","nasty","ordinary","respond","royal","senior","split","strain","struggle","swim","train","upper","wash","yellow","convert","crash","dependent","fold","funny","grab","hide","miss","permit","quote","recover","resolve","roll","sink","slip","spare","suspect","sweet","swing","twist","upstairs","usual","abroad","brave","calm","concentrate","estimate","grand","male","mine","prompt","quiet","refuse","regret","reveal","rush","shake","shift","shine","steal","suck","surround","bear","brilliant","dare","dear","delay","drunk","female","hurry","inevitable","invite","kiss","neat","pop","punch","quit","reply","representative","resist","rip","rub","silly","smile","spell","stretch","stupid","tear","temporary","tomorrow","wake","wrap","yesterday","Thomas","Tom","Lieuwe"];

  var name = capFirst(name1[getRandomInt(0, name1.length + 1)]) + ' ' + capFirst(name2[getRandomInt(0, name2.length + 1)]);
  return name;

}

const makeRandomTeam = async() => {
  //https://img.manners.nl/images/qjWZ4dy0VhFy3b67bKoXggkMwlU=/375x211/filters:quality(80):format(jpeg):background_color(fff)/https%3A%2F%2Fwww.manners.nl%2Fwp-content%2Fuploads%2F2022%2F02%2Fbored-ape-yacht-club-nft-scams-oplicters-herkennen.jpg
  try {
    var players_team = []
    let n = 0;
    while (n < 5) {
      players_team.push(
        {
          captain:false,
          valo_name:generateName(),
          valo_tag:"TEST"
        }
        )
      n++;
    }
    var name_team = generateName()
    var logo_list = [
      "https://www.larvalabs.com/public/images/cryptopunks/punk7252.png",
      "https://s3.coinmarketcap.com/generated/nft/collections/raritysniper-mutant-ape-yacht-club.png",
      "https://img.manners.nl/images/qjWZ4dy0VhFy3b67bKoXggkMwlU=/375x211/filters:quality(80):format(jpeg):background_color(fff)/https%3A%2F%2Fwww.manners.nl%2Fwp-content%2Fuploads%2F2022%2F02%2Fbored-ape-yacht-club-nft-scams-oplicters-herkennen.jpg",
      "https://lh3.googleusercontent.com/ZUpzYyb-MkEhWrKnQRGEOWKko6YhZrKOzWLAM9OlEsdnWdYTRqQ2pit2wVnH2F0Qr5cbjf0O9YNJ9a88ptFP3wkpfC1zNGbfBRGs5w=s0",
      "https://lh3.googleusercontent.com/j1j1EgcmdvDDJMDkMhFawnfnaQ7GtBQnI5rL2gm5c_aeJLupYmtGekLUXiorwEKHYVF5a07WDJMhwSlk_bnvdSkHZc3uqnByxpyS=s0",
      "https://lh3.googleusercontent.com/p_pNvkLlxRZbGoZEPMv0xPuAg0vTDF4RoOWECSv6N-30bPheFvL9-8gRj2FFEpY3ftwJ_uH_hhvwrTlxbzrCp9oPUW-ztqzxpXFMUA=w600",
      "https://lh3.googleusercontent.com/BtqBMQaoaFGuehda3X_LpmbjA1WGcOXUJRjrsrSUomDd_6LEkSStfWazIg7SDpIa63y9RXrD-17FSlIc0G24BlN-DTvQuE3ymOtyhnM=s0",
      "https://lh3.googleusercontent.com/tzaB3daDWPSIxcbpRKHRkEpMp_WqPmGDJYFIj-9I2_TTi0HTBLWp1pTeWfVFCOjmJowXp-UQpkNeQKZ1-pv2g-jANoa5JkDwVf9S=s0",
      "https://lh3.googleusercontent.com/XdrMywW0dpp3Zjj3bGKzp12sSSIIa7PWEF8MY8YSh1jEv0KMPWgwVP07Btqe3vtC_jPbXJX8d2qtJ80RTj8pZDrHVZc-5zE7N8sS=w600",
      "https://lh3.googleusercontent.com/syPfIxSY8MZXwmme4xUUWPCzuTXvn1LYao-LGIYSGALQn9rsX0cDkMHnOtm1FPaA9p-GNbI4Kgj3SccP8wPGJ6aX3pa4sUCmwwLl810=w600"
    ]
    var toadddict = {
      logo:logo_list[Math.floor(Math.random() * logo_list.length)],
      name: name_team,
      players:players_team
    }
    await addDoc(collection(db, "teams"), 
    toadddict
    )
    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

const getCompositionTeam = async(team) => {
  const q = query(collection(db, "current_match"));
  const current_match_doc = await getDocs(q);
  if(team == "blue"){
    const usersteam = current_match_doc.docs[0].data().team_blue
    const toreturn = []
    for (let i = 0; i < usersteam.length; i++) {
      toreturn.push(usersteam[i])
    }
    return toreturn
  }else{
    const usersteam = current_match_doc.docs[0].data().team_red
    const toreturn = []
    for (let i = 0; i < usersteam.length; i++) {
      toreturn.push(usersteam[i])
    }
    return toreturn
  }
};

const reset_all = async() => {
  const q = query(collection(db, "current_match"));
  const current_match_doc = await getDocs(q);
  const teams = ["red", "blue"]
  const docref_change = doc(db,"current_match",current_match_doc.docs[0].id)
  var current_match = {
    team_blue:[{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"}],
    team_red:[{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"},{anchored:false,name:"placeholder_queue_valo"}]
  }
  await updateDoc(docref_change,current_match);
  await clearqueue();
}

const bottomqueuereplaceteam = async(team) => {
  //get all the members from the team
  const q = query(collection(db, "current_match"));
  const current_match_doc = await getDocs(q);
  const current_match = current_match_doc.docs[0].data();
  const docref_change = doc(db,"current_match",current_match_doc.docs[0].id)
  if(team == "blue"){
    const usersteam = current_match_doc.docs[0].data().team_blue
    for (let i = 0; i < usersteam.length; i++) {
      console.log(usersteam[i].anchored);
      if(usersteam[i].anchored == false){
        await deletefrommatch(usersteam[i],team);
        if (usersteam[i].name != "placeholder_queue_valo"){
          await addtoqueue(usersteam[i].name);
        }
      }
    }
    const teamcomp = await getCompositionTeam(team)
    await NewTeamCompMessage(teamcomp,team)
  }else{
    const usersteam = current_match_doc.docs[0].data().team_red
    for (let i = 0; i < usersteam.length; i++) {
      console.log(usersteam[i]);
      console.log(team);
      if(usersteam[i].anchored == false){
        console.log(usersteam[i]);
        await deletefrommatch(usersteam[i],team);
        if (usersteam[i].name != "placeholder_queue_valo"){
          await addtoqueue(usersteam[i].name);
        }
      }
    }
    const teamcomp = await getCompositionTeam(team)
    await NewTeamCompMessage(teamcomp,team)
  }
}

const changeanchoruser = async(user,team) => {
  const q = query(collection(db, "current_match"));
  const current_match_doc = await getDocs(q);
  const current_match = current_match_doc.docs[0].data();
  const docref_change = doc(db,"current_match",current_match_doc.docs[0].id)
  if(team == "blue"){
    const usersteam = current_match_doc.docs[0].data().team_blue
    const index = usersteam.findIndex(x => x.name ===user.name);
    console.log(usersteam[index].anchored);
    if(usersteam[index].anchored === true){
      usersteam[index].anchored = false
    }else{
      usersteam[index].anchored = true
    }
    current_match.team_blue = usersteam;
    // update record of current_match
    updateDoc(docref_change,current_match);
  }else{
    const usersteam = current_match_doc.docs[0].data().team_red
    console.log(usersteam);
    const index = usersteam.findIndex(x => x.name ===user.name);
    console.log(usersteam[index].anchored);
    if(usersteam[index].anchored === true){
      usersteam[index].anchored = false
    }else{
      usersteam[index].anchored = true
    }
    current_match.team_red = usersteam;
    // update record of current_match
    updateDoc(docref_change,current_match);
  }
}

const replacefrommatch = async(user,team) => {
  await deletefrommatch(user,team);
  await addtoqueue(user.name);
  await bumptofirst(user.name);
}

const bottomqueuereplacefrommatch = async(user,team) => {
  await deletefrommatch(user,team);
  await addtoqueue(user.name);
}

const modplayself = async(user) => {
  const qu = query(collection(db, "users"), where("uid", "==", user));
  const docus = await getDocs(qu);
  const data = docus.docs[0].data();
  const replacement_user = {"name":data.valorant_name,"anchored":false};
  const q = query(collection(db, "current_match"));
  const current_match_doc = await getDocs(q);
  const current_match = current_match_doc.docs[0].data();
  const docref_change = doc(db,"current_match",current_match_doc.docs[0].id)
  const usersteam = current_match_doc.docs[0].data().team_blue
  const toreplaceuser = current_match_doc.docs[0].data().team_blue[0]
  usersteam.splice(0, 1); 
  usersteam.push(replacement_user)
  console.log(usersteam);
  // update current_match
  current_match.team_blue = usersteam;
  // update record of current_match
  updateDoc(docref_change,current_match);
  await addtoqueue(toreplaceuser.name);
  await bumptofirst(toreplaceuser.name);
}

const isUserInQueue = async (user) => {
  const q = query(collection(db, "queue"), where("name", "==", user));
  const doc = await getDocs(q);
  console.log(doc.docs.length);
  if (doc.docs.length == 0){
    return false
  }
  else{
    return true
  }
}

const logInWithEmailAndPassword = async (email, password) => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
};

const registerWithEmailAndPassword = async (email, password) => {
    try {
      const res = await createUserWithEmailAndPassword(auth, email, password);
      const user = res.user;
      console.log(user.uid);
      /*alert(user.uid);
      alert("writing in user database");*/
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
};

const getValUserDocUid = async (tosearchuser) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", tosearchuser));
    const doc = await getDocs(q);
    return doc.docs[0].id
  } catch (error) {
    console.error(error);
  }
};

const updateValUserInfo = async (docid,toupdatedict) => {
  try {
    var docreference = doc(db,"users",docid)
    console.log(docid);
    console.log(toupdatedict);
    updateDoc(docreference,toupdatedict);
  } catch (error) {
    console.error(error);
  }
};

const getValUserCredentials = async (tosearchuser) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", tosearchuser));
    const doc = await getDocs(q);
    const data = doc.docs[0].data().type_user;
    return data
  } catch (error) {
    console.error(error);
    return "error";
  }
};

const getValUserInfo = async (tosearchuser) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", tosearchuser));
    const doc = await getDocs(q);
    const data = doc.docs[0].data();
    return data
  } catch (error) {
    console.error(error);
  }
};

const valUserExists = async (tosearchuser) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", tosearchuser));
    const doc = await getDocs(q);
    const data = doc.docs[0].data();
    console.log(data);
    return true
  } catch (err) {
    console.error(err);
    return false
  }
};

const createValorantUser = async (NewValorantName,NewTag,mailuid) => {
  try {
    await addDoc(collection(db, "users"), 
    { type_user:"user",
      valorant_name:NewValorantName,
      valorant_tag:NewTag,
      uid:mailuid,
      tracker_registered:true
    }
      )
    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

const createNonRegisteredValorantUser = async (NewValorantName,NewTag,mailuid) => {
  try {
    await addDoc(collection(db, "users"), 
    { type_user:"user",
      valorant_name:NewValorantName,
      valorant_tag:NewTag,
      uid:mailuid,
      tracker_registered:false,
      current_tier:"Unrated",
      current_tier_icon:"https://trackercdn.com/cdn/tracker.gg/valorant/icons/tiers/0.png",
      max_tier:"Unrated",
      max_tier_icon:"https://trackercdn.com/cdn/tracker.gg/valorant/icons/tiers/0.png",
      time_played:{hours_played:0,minutes_played:0},
      tier_value : 0,
      last_updated:Date.now()
    }
      )
    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

const sendPasswordReset = async (email) => {
    try {
      console.log("about to send email");
      await sendPasswordResetEmail(auth, email);
      alert("Password reset link sent!");
      console.log("email send");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
};

const logout = () => {
    signOut(auth);
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
export {
    auth,
    db,
    signInWithGoogle,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    sendPasswordResetEmail,
    logout,
    createValorantUser,
    valUserExists,
    getValUserDocUid,
    getValUserInfo,
    updateValUserInfo,
    getValUserCredentials,
    isUserInQueue,
    addtoqueue,
    deletefromqueue,
    bumptofirst,
    deletefrommatch,
    replacefrommatch,
    modplayself,
    bottomqueuereplacefrommatch,
    changeanchoruser,
    bottomqueuereplaceteam,
    promotetomod,
    demotetouser,
    makeRandomTeam,
    getBoolRegistration,
    get_all_registrable_tournaments,
    getBoolUserInTourney,
    leaveTournament,
    joinTournament,
    clearqueue,
    reset_all,
    getCompositionTeam,
    createNonRegisteredValorantUser
  };